import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, defer } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoaderService {
    /**
     * Observable qui indique si le loader est actif.
     */
    private readonly active = new BehaviorSubject<boolean>(false);
    readonly active$ = this.active.asObservable();

    /**
     * Affiche le loader.
     */
    show(): void {
        this.active.next(true);
    }

    /**
     * Masque le loader.
     */
    hide(): void {
        this.active.next(false);
    }

    /**
     * Fait tourner le loader autour d'un observable.'
     */
    operator<T>() {
        return (source: Observable<T>) =>
            defer(() => {
                this.show();
                return source.pipe(finalize(() => this.hide()));
            });
    }
}
